<template>
  <app-button
    class="!text-primary"
    color="light"
    :href="url"
    icon="mdi:linkedin"
    size="lg"
    @click="$analytics.track('certificate_add_to_linkedin_clicked')"
  >
    {{ $t("certificate.add_to_linkedin_label") }}
  </app-button>
</template>

<script lang="ts" setup>
import type { CertificateView } from "~~/model/certificate.model";

const properties = defineProps<{
  certificate: CertificateView;
}>();

const issueDate = computed(() => new Date(properties.certificate.created_at));
const {
  public: {
    apps: { websiteBaseUrl },
  },
} = useRuntimeConfig();

const url = computed(() => {
  const title = properties.certificate.track
    ? `${properties.certificate.track.title} - ${properties.certificate.track.organization.name}`
    : properties.certificate.session.course.title;

  return `https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME&name=${encodeURIComponent(
    title,
  )}&organizationId=93318033&issueYear=${issueDate.value.getFullYear()}&
issueMonth=${issueDate.value.getMonth() + 1}&certUrl=${encodeURIComponent(
    `${websiteBaseUrl}/certificates/${properties.certificate.id}`,
  )}&certId=${properties.certificate.id}`;
});

const { $analytics } = useNuxtApp();
</script>
